/**
 * Return the initials of the provided [name]
 *
 * @param name
 * @param numberOfLetters - number of initial letters(depends on how many words the [name] has)
 * @returns
 */
function getNameInitials(name: string | null, numberOfLetters = 2): string {
  if (!name) return "";

  const splittedName = name.toUpperCase().split(" ");
  let nameInitials = "";
  const length = numberOfLetters > splittedName.length ? splittedName.length : numberOfLetters;

  for (let i = 0; i < length; i += 1) {
    nameInitials += splittedName[i].charAt(0);
  }

  return nameInitials;
}

export default getNameInitials;
